var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('h1',[_c('router-link',{staticClass:"btn",attrs:{"to":"/acceuil"}},[_vm._v("Info en continu")])],1),_c('p',{staticClass:"news"},[_vm._v("News provenant de l'API GNEWS")])])])}
var staticRenderFns = []

export { render, staticRenderFns }